document.addEventListener("DOMContentLoaded", function () {
  // Select all button blocks and get the value from sessionStorage
  const buttonBlocks = document.querySelectorAll(".header-btn_block");
  let dataButtonBlockValue = sessionStorage.getItem("dataButtonBlockValue");
  // Function to add 'active_btn' class to the corresponding button based on stored value
  const setActiveButton = () => {
    buttonBlocks.forEach((buttonBlock) => {
      buttonBlock.classList.remove("active_btn");
    });
    buttonBlocks.forEach((buttonBlock) => {
      const buttonDataValue = buttonBlock.getAttribute("data-button-block");
      if (buttonDataValue === dataButtonBlockValue) {
        buttonBlock.classList.add("active_btn");
      }
    });
  };

  // Function to add 'active_logo' class to the corresponding anchor tag based on stored value
  const setActiveLogo = () => {
    const anchorTags = document.querySelectorAll(".header_logo");
    anchorTags.forEach((anchorTag) => {
      anchorTag.classList.remove("active_logo");
    });

    if (dataButtonBlockValue) {
      const activeLogoAnchorTag = document.querySelector(
        `.header_logo.${dataButtonBlockValue}`
      );
      if (activeLogoAnchorTag) {
        activeLogoAnchorTag.classList.add("active_logo");
      }
    } else {
      // If sessionStorage is empty, add 'active_logo' class to the first anchor tag with class "MEN"
      const defaultLogoAnchorTag = document.querySelector(".header_logo.MEN");
      if (defaultLogoAnchorTag) {
        defaultLogoAnchorTag.classList.add("active_logo");
      }
    }
  };

  // Function to set default button and logo when sessionStorage is empty
  const setDefaultButtonAndLogo = () => {
    dataButtonBlockValue = buttonBlocks[0].getAttribute("data-button-block");
    buttonBlocks.forEach((btn)=>{
         if(btn.getAttribute("data-button-block") ==  dataButtonBlockValue){
          btn.classList.add("active_btn");
         }
    }) 
    sessionStorage.setItem("dataButtonBlockValue", dataButtonBlockValue);
  };

  // Check if dataButtonBlockValue exists
  if (dataButtonBlockValue) {
    setActiveButton();
  } else {
    setDefaultButtonAndLogo();
  }
  // Add click event listener to each button block
  buttonBlocks.forEach((buttonBlock) => {
    buttonBlock.addEventListener("click", () => {
      buttonBlocks.forEach((btn) => btn.classList.remove("active_btn"));
      buttonBlock.classList.add("active_btn");
      dataButtonBlockValue = buttonBlock.getAttribute("data-button-block");
      sessionStorage.setItem("dataButtonBlockValue", dataButtonBlockValue);
      setActiveLogo();
    });
  });
  setActiveLogo();
});

document.addEventListener("DOMContentLoaded", function() {
  let activeBtn = document.querySelector('.active_btn');
  if (activeBtn && activeBtn.textContent.trim() === 'MEN') {
      let colorFamilyWrapper = document.querySelector('.color-family-wrapper');
      let hideMen = document.querySelector('.hide-in-men');
      if (colorFamilyWrapper) {
         colorFamilyWrapper.classList.add('hidden');
         hideMen.classList.add('hidden');
      }
  } 
});

